import { ChevronRight, CheckCircle2 } from "lucide-react";
import { URGENCY, fmtDate } from "./hrUtils";

export const HrTodoList = ({ todos, onOpen }) => {
  if (!todos.length) {
    return (
      <div data-testid="hr-todo-empty" className="p-6 text-center">
        <CheckCircle2 className="w-8 h-8 mx-auto text-emerald-500 mb-2" />
        <div className="font-heading font-black uppercase tracking-tight">Wszystko w porządku</div>
        <div className="text-xs text-zinc-500 mt-1">Żadnych braków ani kończących się terminów.</div>
      </div>
    );
  }
  return (
    <div data-testid="hr-todo-list" className="divide-y divide-zinc-100">
      {URGENCY.map((u) => {
        const rows = todos.filter((t) => t.urgency === u.key);
        if (!rows.length) return null;
        return (
          <section key={u.key} data-testid={`hr-todo-group-${u.key}`}>
            <header className="flex items-center justify-between px-4 py-2 bg-zinc-50">
              <span className={`inline-flex items-center h-6 px-2 rounded-full ring-1 text-[10px] font-black uppercase tracking-wider ${u.tone}`}>{u.label} · {rows.length}</span>
              <span className="text-[10px] font-mono text-zinc-400">{u.desc}</span>
            </header>
            <ul className="stagger">
              {rows.map((t, i) => (
                <li key={`${t.employee_id}-${t.kind}-${t.doc_type}-${t.due_date}-${i}`}>
                  <button type="button" onClick={() => onOpen(t.employee_id, t.doc_type)} data-testid={`hr-todo-${t.employee_id}-${t.kind}-${t.doc_type || "x"}${t.due_date ? `-${t.due_date}` : ""}`}
                    className="w-full text-left px-4 py-2.5 flex items-start gap-3 hover:bg-zinc-50 transition-colors">
                    <div className="min-w-0 flex-1">
                      <div className="text-xs font-black uppercase tracking-tight truncate">{t.employee_name}</div>
                      <div className="text-sm text-zinc-700 leading-snug">{t.label}</div>
                      {t.due_date && <div className="text-[10px] font-mono text-zinc-400 mt-0.5">termin {fmtDate(t.due_date)}{t.days_left != null && t.days_left >= 0 ? ` · za ${t.days_left} dni` : t.days_left != null ? ` · ${-t.days_left} dni temu` : ""}</div>}
                    </div>
                    <ChevronRight className="w-4 h-4 text-zinc-300 shrink-0 mt-1" />
                  </button>
                </li>
              ))}
            </ul>
          </section>
        );
      })}
    </div>
  );
};
